import { countries } from './countries';
export const getCountryNameByCode = (code) => { var _a; return (_a = countries.find((c) => c.code === code)) === null || _a === void 0 ? void 0 : _a.name; };
